import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const TeamLegalCasesState = {
  legal_cases: [],
  restrictedLegalCases: [],
}

export const TeamLegalCasesActions = {
  getTeamLegalCases: async ({ commit }, teamId) => {
    return axiosRequest.
      get(`/teams/${teamId}/legal_cases`).
      then(({ data }) => {
        commit('setTeamLegalCases', data)
        return data
      }).
      catch(handleError)
  },

  excludeLegalCase: async (_, { teamId, legalCaseId }) => {
    return axiosRequest.
      delete(`/teams/${teamId}/legal_cases/${legalCaseId}`).
      then(({ data }) => {
        return data
      }).
      catch(handleError)
  },

  getRestrictedLegalCases: async ({ commit }, teamId) => {
    return axiosRequest.
      get(`/teams/${teamId}/restricted_resources/legal_cases`).
      then(({ data }) => {
        commit('setRestrictedLegalCases', data)
        return data
      }).
      catch(handleError)
  },

  permitLegalCase: async (_, { teamId, legalCaseId }) => {
    return axiosRequest.
      post(`/teams/${teamId}/legal_cases/${legalCaseId}/permit`).
      then(({ data }) => {
        return data
      }).
      catch(handleError)
  },
}

export const TeamLegalCasesGetters = {
  teamLegalCases: state => state.legal_cases || [],

  restrictedLegalCases: state => (state.restrictedLegalCases || []).map(legalCase => ({
    ...legalCase,
    type: 'Legal Case',
  })),
}

export const TeamLegalCasesMutations = {
  setTeamLegalCases: (state, legalCases) => (state.legal_cases = legalCases),
  setRestrictedLegalCases: (state, legalCases) => (state.restrictedLegalCases = legalCases),
}
